import axios from '@/utils/axios'
// 添加追剧列表
export function listVideo(query) {
    return axios({
        url: '/video/strategy/getList',
        method: 'get',
        params: query
    })
}
// 详情
export function details(query) {
    return axios({
        url: '/video/strategy/details',
        method: 'get',
        params: query
    })
}
// 删除
export function del(query) {
    return axios({
        url: '/video/strategy/delete',
        method: 'get',
        params: query
    })
}
// 批量上架
export function upOrDown(query) {
    return axios({
        url: '/video/strategy/upOrDownVideo',
        method: 'post',
        data: query
    })
}
// 添加短剧
export function addVideo(query) {
    return axios({
        url: '/video/strategy/addInfo',
        method: 'post',
        data: query
    })
}
// 获取标签
export function listLabel(query) {
    return axios({
        url: '/lable/getList',
        method: 'get',
        params: query
    })
}
// 一键填充剧集id
export function addEpisodeDitch(query) {
    return axios({
        url: '/video/strategy/addEpisodeDitch',
        method: 'get',
        params: query
    })
}